import React from 'react';
import { InputAdornment, makeStyles, TextField } from '@material-ui/core';
import clsx from 'clsx';
import { Search } from '@material-ui/icons';
import { AutoSuggest } from 'common';
import { skills } from 'controllers/taxonomies';
import { useState } from 'react';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  searchIcon: {
    width: 17.5,
    height: 17.5,
  },
  input: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'normal',
    lineHeight: 0.15,
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 87)',

    '& ::placeholder': {
      color: 'rgba(0, 0, 0, 1)',
    },
  },
  inputContainer: {
    height: 56,
    padding: 0,
    border: 0,
  },
}));

const SkillSearchBox = ({ id, inputProps = {}, onSelectSkill }) => {
  const classes = useStyles();
  const [selectedSkill, setSelectedSkill] = useState('');

  const fetchSkills = async (value) => {
    const skillArray = await skills(value);
    return await skillArray.response.map(({ skill }) => skill);
  };

  const onSelect = (e, value) => {
    onSelectSkill(value.suggestion);
    setSelectedSkill('');
  };

  const onChange = (e) => {
    setSelectedSkill(e.target.value);
  };

  const onEnter = (e) => {
    if (e.key === 'Enter' && Boolean(selectedSkill.trim())) {
      onSelect(e, { suggestion: selectedSkill.trim() });
    }
  };

  const renderInputComponent = (props) => {
    return (
      <TextField
        id={id}
        variant="outlined"
        fullWidth
        InputProps={{
          classes: { root: classes.input },
          endAdornment: (
            <InputAdornment position="end">
              <Search classes={{ root: classes.searchIcon }} />
            </InputAdornment>
          ),
        }}
        {...props}
        onKeyPress={onEnter}
        className={classes.inputContainer}
        {...inputProps}
      />
    );
  };

  return (
    <div className={clsx(classes.container)}>
      <AutoSuggest
        placeholder="Search here"
        value={selectedSkill}
        name="jobLocationLocal"
        onChange={onChange}
        fetchSuggestions={fetchSkills}
        onSelect={onSelect}
        InputComponent={renderInputComponent}
      />
    </div>
  );
};

export default SkillSearchBox;
